export const PREFIX = 'packages.collect_package';
